import type { GamePlayerProjectionTrading } from '@library/types/trading';
import { usePublishProjectionsMutation } from '@bo-services/projectionsApi';

export const useTradingActions = () => {
  const [
    publishProjections,
    {
      error: publishProjectionsError,
      isError: isPublishProjectionsError,
      isSuccess: isPublishProjectionsSuccess,
      isUninitialized: isPublishProjectionsUninitialized,
      reset: resetCreateProjections
    }
  ] = usePublishProjectionsMutation();

  const handlePublishProjections = async (
    leagueId: string,
    modifiedProjections: Array<GamePlayerProjectionTrading>
  ) => {
    const createUpdateProjections = modifiedProjections.map((projection) => {
      const {
        autoTrade,
        boardTime,
        description,
        durationId,
        foreignId,
        gameId,
        gameModeIds,
        inGame,
        leagueId: projectionLeagueId = leagueId,
        maxProbabilityOfMore,
        minProbabilityOfMore,
        playerId: projectionPlayerId,
        playerImage,
        playerName,
        position,
        projectionId,
        projectionValue,
        startTime,
        displayTime,
        team,
        teamName,
        targetProbabilityOfMore
      } = projection;

      return {
        players: projectionPlayerId
          ? [{ id: Number(projectionPlayerId) }]
          : [
              {
                foreign_id: foreignId,
                image_url: playerImage,
                league_id: Number(projectionLeagueId),
                name: playerName,
                position,
                sportsradar_id: true, // this needs to be dynamic once other sources come into player
                team,
                team_name: teamName
              }
            ],
        projections: [
          {
            id: projectionId ? Number(projectionId) : null,
            auto_trade: autoTrade,
            board_time: boardTime,
            description: description || 'TODO',
            duration_id: Number(durationId),
            game_id: gameId,
            game_mode_ids: gameModeIds,
            in_game: inGame,
            league_id: Number(projectionLeagueId),
            line_score: String(projectionValue),
            max_probability_of_more: maxProbabilityOfMore,
            min_probability_of_more: minProbabilityOfMore,
            rank: projection.rank ? Number(projection.rank) : 0,
            start_time: startTime,
            display_time: displayTime,
            stat_type_id: Number(projection.statTypeId),
            status: projection.status || 'pre_game',
            target_probability_of_more: targetProbabilityOfMore
          }
        ]
      };
    });

    await publishProjections({
      projections_request: createUpdateProjections
    }).catch(() => {});
  };

  return {
    handlePublishProjections,
    publishProjectionsError,
    isPublishProjectionsError,
    isPublishProjectionsSuccess,
    isPublishProjectionsUninitialized,
    resetCreateProjections
  };
};
